import useClientState from '@/state/useClientState';

const useSearchStore = () => {
  const searchParams = useClientState((state) => state.searchParams);

  const advancedSearchParams = useClientState((state) => state.advancedSearchParams);
  const setAdvancedSearchParams = useClientState((state) => state.setAdvancedSearchParams);
  const showAdvancedSearchDialog = useClientState((state) => state.showAdvancedSearchDialog);
  const setShowAdvancedSearchDialog = useClientState((state) => state.setShowAdvancedSearchDialog);

  const clearSearchField = useClientState((state) => state.clearSearchField);
  const setClearSearchField = useClientState((state) => state.setClearSearchField);
  const clearSearch = useClientState((state) => state.clearSearch);
  return {
    searchParams,
    advancedSearchParams,
    setAdvancedSearchParams,
    showAdvancedSearchDialog,
    setShowAdvancedSearchDialog,
    clearSearchField,
    setClearSearchField,
    clearSearch,
  };
};
export default useSearchStore;
